// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'
import { string } from "yup";

const obj = {
  field: [
    {
      title: "List of Keyword",
      attr: "content",
      value: "",
      id: "Keyword",
      placeholder: "List of Keyword",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string()
        .nullable()
        .trim("Initially whitespace are not allowed")
        .required("List of keywords is Required"),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
  ],
  example: [
    {
      title: "List of keywords",
      attr: "content",
      value: `Cricket,\nBatting,\nBowling,\nCatch,\nHow's that,\nWicket,\nBowled`,

      id: "keywords",
      placeholder: "List of keywords",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string()
        .nullable()
        .trim("Initially whitespace are not allowed")
        .required("List of keywords is Required"),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
  ],

  editor: {
    output: `-Commercial: buy, purchase, sale\n-Transactional: book, reserve, schedule\n-Informational: learn, read`,
                      
  },
};

export default obj;
